var _path, _path2, _g, _rect, _path3, _rect2, _path4, _path5, _path6, _path7, _circle, _g2, _circle2, _g3, _path8, _circle3, _rect3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g10, _g11, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _path29, _path30, _path31, _g12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainGraph(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1060,
    height: 384,
    viewBox: "0 0 1060 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M884.561 129.061C885.146 128.475 885.146 127.525 884.561 126.939L875.015 117.393C874.429 116.808 873.479 116.808 872.893 117.393C872.308 117.979 872.308 118.929 872.893 119.515L881.379 128L872.893 136.485C872.308 137.071 872.308 138.021 872.893 138.607C873.479 139.192 874.429 139.192 875.015 138.607L884.561 129.061ZM158 126.5C157.172 126.5 156.5 127.172 156.5 128C156.5 128.828 157.172 129.5 158 129.5V126.5ZM649.5 126.5C648.672 126.5 648 127.172 648 128C648 128.828 648.672 129.5 649.5 129.5V126.5ZM390 129.5C390.828 129.5 391.5 128.828 391.5 128C391.5 127.172 390.828 126.5 390 126.5V129.5ZM650.778 129.5C651.606 129.5 652.278 128.828 652.278 128C652.278 127.172 651.606 126.5 650.778 126.5V129.5ZM655.889 126.5C655.06 126.5 654.389 127.172 654.389 128C654.389 128.828 655.06 129.5 655.889 129.5V126.5ZM658.444 129.5C659.273 129.5 659.944 128.828 659.944 128C659.944 127.172 659.273 126.5 658.444 126.5V129.5ZM663.556 126.5C662.727 126.5 662.056 127.172 662.056 128C662.056 128.828 662.727 129.5 663.556 129.5V126.5ZM666.111 129.5C666.94 129.5 667.611 128.828 667.611 128C667.611 127.172 666.94 126.5 666.111 126.5V129.5ZM671.222 126.5C670.394 126.5 669.722 127.172 669.722 128C669.722 128.828 670.394 129.5 671.222 129.5V126.5ZM674.029 129.5C674.857 129.5 675.529 128.828 675.529 128C675.529 127.172 674.857 126.5 674.029 126.5V129.5ZM680.145 126.5C679.317 126.5 678.645 127.172 678.645 128C678.645 128.828 679.317 129.5 680.145 129.5V126.5ZM683.203 129.5C684.031 129.5 684.703 128.828 684.703 128C684.703 127.172 684.031 126.5 683.203 126.5V129.5ZM689.319 126.5C688.49 126.5 687.819 127.172 687.819 128C687.819 128.828 688.49 129.5 689.319 129.5V126.5ZM692.377 129.5C693.205 129.5 693.877 128.828 693.877 128C693.877 127.172 693.205 126.5 692.377 126.5V129.5ZM698.493 126.5C697.664 126.5 696.993 127.172 696.993 128C696.993 128.828 697.664 129.5 698.493 129.5V126.5ZM701.551 129.5C702.379 129.5 703.051 128.828 703.051 128C703.051 127.172 702.379 126.5 701.551 126.5V129.5ZM707.667 126.5C706.838 126.5 706.167 127.172 706.167 128C706.167 128.828 706.838 129.5 707.667 129.5V126.5ZM710.725 129.5C711.553 129.5 712.225 128.828 712.225 128C712.225 127.172 711.553 126.5 710.725 126.5V129.5ZM716.841 126.5C716.012 126.5 715.341 127.172 715.341 128C715.341 128.828 716.012 129.5 716.841 129.5V126.5ZM719.899 129.5C720.727 129.5 721.399 128.828 721.399 128C721.399 127.172 720.727 126.5 719.899 126.5V129.5ZM726.014 126.5C725.186 126.5 724.514 127.172 724.514 128C724.514 128.828 725.186 129.5 726.014 129.5V126.5ZM729.072 129.5C729.901 129.5 730.572 128.828 730.572 128C730.572 127.172 729.901 126.5 729.072 126.5V129.5ZM735.188 126.5C734.36 126.5 733.688 127.172 733.688 128C733.688 128.828 734.36 129.5 735.188 129.5V126.5ZM738.246 129.5C739.075 129.5 739.746 128.828 739.746 128C739.746 127.172 739.075 126.5 738.246 126.5V129.5ZM744.362 126.5C743.534 126.5 742.862 127.172 742.862 128C742.862 128.828 743.534 129.5 744.362 129.5V126.5ZM747.42 129.5C748.249 129.5 748.92 128.828 748.92 128C748.92 127.172 748.249 126.5 747.42 126.5V129.5ZM753.536 126.5C752.708 126.5 752.036 127.172 752.036 128C752.036 128.828 752.708 129.5 753.536 129.5V126.5ZM756.594 129.5C757.423 129.5 758.094 128.828 758.094 128C758.094 127.172 757.423 126.5 756.594 126.5V129.5ZM762.71 126.5C761.882 126.5 761.21 127.172 761.21 128C761.21 128.828 761.882 129.5 762.71 129.5V126.5ZM765.768 129.5C766.597 129.5 767.268 128.828 767.268 128C767.268 127.172 766.597 126.5 765.768 126.5V129.5ZM771.884 126.5C771.056 126.5 770.384 127.172 770.384 128C770.384 128.828 771.056 129.5 771.884 129.5V126.5ZM774.942 129.5C775.77 129.5 776.442 128.828 776.442 128C776.442 127.172 775.77 126.5 774.942 126.5V129.5ZM781.058 126.5C780.23 126.5 779.558 127.172 779.558 128C779.558 128.828 780.23 129.5 781.058 129.5V126.5ZM784.116 129.5C784.944 129.5 785.616 128.828 785.616 128C785.616 127.172 784.944 126.5 784.116 126.5V129.5ZM790.232 126.5C789.403 126.5 788.732 127.172 788.732 128C788.732 128.828 789.403 129.5 790.232 129.5V126.5ZM793.29 129.5C794.118 129.5 794.79 128.828 794.79 128C794.79 127.172 794.118 126.5 793.29 126.5V129.5ZM799.406 126.5C798.577 126.5 797.906 127.172 797.906 128C797.906 128.828 798.577 129.5 799.406 129.5V126.5ZM802.464 129.5C803.292 129.5 803.964 128.828 803.964 128C803.964 127.172 803.292 126.5 802.464 126.5V129.5ZM808.58 126.5C807.751 126.5 807.08 127.172 807.08 128C807.08 128.828 807.751 129.5 808.58 129.5V126.5ZM811.638 129.5C812.466 129.5 813.138 128.828 813.138 128C813.138 127.172 812.466 126.5 811.638 126.5V129.5ZM817.754 126.5C816.925 126.5 816.254 127.172 816.254 128C816.254 128.828 816.925 129.5 817.754 129.5V126.5ZM820.812 129.5C821.64 129.5 822.312 128.828 822.312 128C822.312 127.172 821.64 126.5 820.812 126.5V129.5ZM826.927 126.5C826.099 126.5 825.427 127.172 825.427 128C825.427 128.828 826.099 129.5 826.927 129.5V126.5ZM829.985 129.5C830.814 129.5 831.485 128.828 831.485 128C831.485 127.172 830.814 126.5 829.985 126.5V129.5ZM836.101 126.5C835.273 126.5 834.601 127.172 834.601 128C834.601 128.828 835.273 129.5 836.101 129.5V126.5ZM839.159 129.5C839.988 129.5 840.659 128.828 840.659 128C840.659 127.172 839.988 126.5 839.159 126.5V129.5ZM845.275 126.5C844.447 126.5 843.775 127.172 843.775 128C843.775 128.828 844.447 129.5 845.275 129.5V126.5ZM848.333 129.5C849.162 129.5 849.833 128.828 849.833 128C849.833 127.172 849.162 126.5 848.333 126.5V129.5ZM854.449 126.5C853.621 126.5 852.949 127.172 852.949 128C852.949 128.828 853.621 129.5 854.449 129.5V126.5ZM857.507 129.5C858.336 129.5 859.007 128.828 859.007 128C859.007 127.172 858.336 126.5 857.507 126.5V129.5ZM863.623 126.5C862.795 126.5 862.123 127.172 862.123 128C862.123 128.828 862.795 129.5 863.623 129.5V126.5ZM866.681 129.5C867.51 129.5 868.181 128.828 868.181 128C868.181 127.172 867.51 126.5 866.681 126.5V129.5ZM872.797 126.5C871.969 126.5 871.297 127.172 871.297 128C871.297 128.828 871.969 129.5 872.797 129.5V126.5ZM875.855 129.5C876.683 129.5 877.355 128.828 877.355 128C877.355 127.172 876.683 126.5 875.855 126.5V129.5ZM881.971 126.5C881.142 126.5 880.471 127.172 880.471 128C880.471 128.828 881.142 129.5 881.971 129.5V126.5ZM159.487 129.5C160.316 129.5 160.987 128.828 160.987 128C160.987 127.172 160.316 126.5 159.487 126.5V129.5ZM165.436 126.5C164.607 126.5 163.936 127.172 163.936 128C163.936 128.828 164.607 129.5 165.436 129.5V126.5ZM168.41 129.5C169.239 129.5 169.91 128.828 169.91 128C169.91 127.172 169.239 126.5 168.41 126.5V129.5ZM174.359 126.5C173.531 126.5 172.859 127.172 172.859 128C172.859 128.828 173.531 129.5 174.359 129.5V126.5ZM177.333 129.5C178.162 129.5 178.833 128.828 178.833 128C178.833 127.172 178.162 126.5 177.333 126.5V129.5ZM183.282 126.5C182.454 126.5 181.782 127.172 181.782 128C181.782 128.828 182.454 129.5 183.282 129.5V126.5ZM186.256 129.5C187.085 129.5 187.756 128.828 187.756 128C187.756 127.172 187.085 126.5 186.256 126.5V129.5ZM192.205 126.5C191.377 126.5 190.705 127.172 190.705 128C190.705 128.828 191.377 129.5 192.205 129.5V126.5ZM195.179 129.5C196.008 129.5 196.679 128.828 196.679 128C196.679 127.172 196.008 126.5 195.179 126.5V129.5ZM201.128 126.5C200.3 126.5 199.628 127.172 199.628 128C199.628 128.828 200.3 129.5 201.128 129.5V126.5ZM204.103 129.5C204.931 129.5 205.603 128.828 205.603 128C205.603 127.172 204.931 126.5 204.103 126.5V129.5ZM210.051 126.5C209.223 126.5 208.551 127.172 208.551 128C208.551 128.828 209.223 129.5 210.051 129.5V126.5ZM213.026 129.5C213.854 129.5 214.526 128.828 214.526 128C214.526 127.172 213.854 126.5 213.026 126.5V129.5ZM218.974 126.5C218.146 126.5 217.474 127.172 217.474 128C217.474 128.828 218.146 129.5 218.974 129.5V126.5ZM221.949 129.5C222.777 129.5 223.449 128.828 223.449 128C223.449 127.172 222.777 126.5 221.949 126.5V129.5ZM227.897 126.5C227.069 126.5 226.397 127.172 226.397 128C226.397 128.828 227.069 129.5 227.897 129.5V126.5ZM230.872 129.5C231.7 129.5 232.372 128.828 232.372 128C232.372 127.172 231.7 126.5 230.872 126.5V129.5ZM236.821 126.5C235.992 126.5 235.321 127.172 235.321 128C235.321 128.828 235.992 129.5 236.821 129.5V126.5ZM239.795 129.5C240.623 129.5 241.295 128.828 241.295 128C241.295 127.172 240.623 126.5 239.795 126.5V129.5ZM245.744 126.5C244.915 126.5 244.244 127.172 244.244 128C244.244 128.828 244.915 129.5 245.744 129.5V126.5ZM248.718 129.5C249.546 129.5 250.218 128.828 250.218 128C250.218 127.172 249.546 126.5 248.718 126.5V129.5ZM254.667 126.5C253.838 126.5 253.167 127.172 253.167 128C253.167 128.828 253.838 129.5 254.667 129.5V126.5ZM257.641 129.5C258.469 129.5 259.141 128.828 259.141 128C259.141 127.172 258.469 126.5 257.641 126.5V129.5ZM263.59 126.5C262.761 126.5 262.09 127.172 262.09 128C262.09 128.828 262.761 129.5 263.59 129.5V126.5ZM266.564 129.5C267.393 129.5 268.064 128.828 268.064 128C268.064 127.172 267.393 126.5 266.564 126.5V129.5ZM272.513 126.5C271.684 126.5 271.013 127.172 271.013 128C271.013 128.828 271.684 129.5 272.513 129.5V126.5ZM275.487 129.5C276.316 129.5 276.987 128.828 276.987 128C276.987 127.172 276.316 126.5 275.487 126.5V129.5ZM281.436 126.5C280.607 126.5 279.936 127.172 279.936 128C279.936 128.828 280.607 129.5 281.436 129.5V126.5ZM284.41 129.5C285.239 129.5 285.91 128.828 285.91 128C285.91 127.172 285.239 126.5 284.41 126.5V129.5ZM290.359 126.5C289.531 126.5 288.859 127.172 288.859 128C288.859 128.828 289.531 129.5 290.359 129.5V126.5ZM293.333 129.5C294.162 129.5 294.833 128.828 294.833 128C294.833 127.172 294.162 126.5 293.333 126.5V129.5ZM299.282 126.5C298.454 126.5 297.782 127.172 297.782 128C297.782 128.828 298.454 129.5 299.282 129.5V126.5ZM302.256 129.5C303.085 129.5 303.756 128.828 303.756 128C303.756 127.172 303.085 126.5 302.256 126.5V129.5ZM308.205 126.5C307.377 126.5 306.705 127.172 306.705 128C306.705 128.828 307.377 129.5 308.205 129.5V126.5ZM311.179 129.5C312.008 129.5 312.679 128.828 312.679 128C312.679 127.172 312.008 126.5 311.179 126.5V129.5ZM317.128 126.5C316.3 126.5 315.628 127.172 315.628 128C315.628 128.828 316.3 129.5 317.128 129.5V126.5ZM320.103 129.5C320.931 129.5 321.603 128.828 321.603 128C321.603 127.172 320.931 126.5 320.103 126.5V129.5ZM326.051 126.5C325.223 126.5 324.551 127.172 324.551 128C324.551 128.828 325.223 129.5 326.051 129.5V126.5ZM329.026 129.5C329.854 129.5 330.526 128.828 330.526 128C330.526 127.172 329.854 126.5 329.026 126.5V129.5ZM334.974 126.5C334.146 126.5 333.474 127.172 333.474 128C333.474 128.828 334.146 129.5 334.974 129.5V126.5ZM337.949 129.5C338.777 129.5 339.449 128.828 339.449 128C339.449 127.172 338.777 126.5 337.949 126.5V129.5ZM343.897 126.5C343.069 126.5 342.397 127.172 342.397 128C342.397 128.828 343.069 129.5 343.897 129.5V126.5ZM346.872 129.5C347.7 129.5 348.372 128.828 348.372 128C348.372 127.172 347.7 126.5 346.872 126.5V129.5ZM352.821 126.5C351.992 126.5 351.321 127.172 351.321 128C351.321 128.828 351.992 129.5 352.821 129.5V126.5ZM355.795 129.5C356.623 129.5 357.295 128.828 357.295 128C357.295 127.172 356.623 126.5 355.795 126.5V129.5ZM361.744 126.5C360.915 126.5 360.244 127.172 360.244 128C360.244 128.828 360.915 129.5 361.744 129.5V126.5ZM364.718 129.5C365.546 129.5 366.218 128.828 366.218 128C366.218 127.172 365.546 126.5 364.718 126.5V129.5ZM370.667 126.5C369.838 126.5 369.167 127.172 369.167 128C369.167 128.828 369.838 129.5 370.667 129.5V126.5ZM373.641 129.5C374.469 129.5 375.141 128.828 375.141 128C375.141 127.172 374.469 126.5 373.641 126.5V129.5ZM379.59 126.5C378.761 126.5 378.09 127.172 378.09 128C378.09 128.828 378.761 129.5 379.59 129.5V126.5ZM382.564 129.5C383.393 129.5 384.064 128.828 384.064 128C384.064 127.172 383.393 126.5 382.564 126.5V129.5ZM388.513 126.5C387.684 126.5 387.013 127.172 387.013 128C387.013 128.828 387.684 129.5 388.513 129.5V126.5ZM649.5 129.5H650.778V126.5H649.5V129.5ZM655.889 129.5H658.444V126.5H655.889V129.5ZM663.556 129.5H666.111V126.5H663.556V129.5ZM671.222 129.5H672.5V126.5H671.222V129.5ZM672.5 129.5H674.029V126.5H672.5V129.5ZM680.145 129.5H683.203V126.5H680.145V129.5ZM689.319 129.5H692.377V126.5H689.319V129.5ZM698.493 129.5H701.551V126.5H698.493V129.5ZM707.667 129.5H710.725V126.5H707.667V129.5ZM716.841 129.5H719.899V126.5H716.841V129.5ZM726.014 129.5H729.072V126.5H726.014V129.5ZM735.188 129.5H738.246V126.5H735.188V129.5ZM744.362 129.5H747.42V126.5H744.362V129.5ZM753.536 129.5H756.594V126.5H753.536V129.5ZM762.71 129.5H765.768V126.5H762.71V129.5ZM771.884 129.5H774.942V126.5H771.884V129.5ZM781.058 129.5H784.116V126.5H781.058V129.5ZM790.232 129.5H793.29V126.5H790.232V129.5ZM799.406 129.5H802.464V126.5H799.406V129.5ZM808.58 129.5H811.638V126.5H808.58V129.5ZM817.754 129.5H820.812V126.5H817.754V129.5ZM826.927 129.5H829.985V126.5H826.927V129.5ZM836.101 129.5H839.159V126.5H836.101V129.5ZM845.275 129.5H848.333V126.5H845.275V129.5ZM854.449 129.5H857.507V126.5H854.449V129.5ZM863.623 129.5H866.681V126.5H863.623V129.5ZM872.797 129.5H875.855V126.5H872.797V129.5ZM881.971 129.5H883.5V126.5H881.971V129.5ZM158 129.5H159.487V126.5H158V129.5ZM165.436 129.5H168.41V126.5H165.436V129.5ZM174.359 129.5H177.333V126.5H174.359V129.5ZM183.282 129.5H186.256V126.5H183.282V129.5ZM192.205 129.5H195.179V126.5H192.205V129.5ZM201.128 129.5H204.103V126.5H201.128V129.5ZM210.051 129.5H213.026V126.5H210.051V129.5ZM218.974 129.5H221.949V126.5H218.974V129.5ZM227.897 129.5H230.872V126.5H227.897V129.5ZM236.821 129.5H239.795V126.5H236.821V129.5ZM245.744 129.5H248.718V126.5H245.744V129.5ZM254.667 129.5H257.641V126.5H254.667V129.5ZM263.59 129.5H266.564V126.5H263.59V129.5ZM272.513 129.5H275.487V126.5H272.513V129.5ZM281.436 129.5H284.41V126.5H281.436V129.5ZM290.359 129.5H293.333V126.5H290.359V129.5ZM299.282 129.5H302.256V126.5H299.282V129.5ZM308.205 129.5H311.179V126.5H308.205V129.5ZM317.128 129.5H320.103V126.5H317.128V129.5ZM326.051 129.5H329.026V126.5H326.051V129.5ZM334.974 129.5H337.949V126.5H334.974V129.5ZM343.897 129.5H346.872V126.5H343.897V129.5ZM352.821 129.5H355.795V126.5H352.821V129.5ZM361.744 129.5H364.718V126.5H361.744V129.5ZM370.667 129.5H373.641V126.5H370.667V129.5ZM379.59 129.5H382.564V126.5H379.59V129.5ZM388.513 129.5H390V126.5H388.513V129.5Z",
    fill: "#B8C3D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.939 250.939C156.354 251.525 156.354 252.475 156.939 253.061L166.485 262.607C167.071 263.192 168.021 263.192 168.607 262.607C169.192 262.021 169.192 261.071 168.607 260.485L160.121 252L168.607 243.515C169.192 242.929 169.192 241.979 168.607 241.393C168.021 240.808 167.071 240.808 166.485 241.393L156.939 250.939ZM883.5 253.5C884.328 253.5 885 252.828 885 252C885 251.172 884.328 250.5 883.5 250.5L883.5 253.5ZM386.5 253.5C387.328 253.5 388 252.828 388 252C388 251.172 387.328 250.5 386.5 250.5L386.5 253.5ZM669.5 250.5C668.672 250.5 668 251.172 668 252C668 252.828 668.672 253.5 669.5 253.5L669.5 250.5ZM384.977 250.5C384.148 250.5 383.477 251.172 383.477 252C383.477 252.828 384.148 253.5 384.977 253.5L384.977 250.5ZM378.883 253.5C379.712 253.5 380.383 252.828 380.383 252C380.383 251.172 379.712 250.5 378.883 250.5L378.883 253.5ZM375.837 250.5C375.008 250.5 374.337 251.172 374.337 252C374.337 252.828 375.008 253.5 375.837 253.5L375.837 250.5ZM369.743 253.5C370.572 253.5 371.243 252.828 371.243 252C371.243 251.172 370.572 250.5 369.743 250.5L369.743 253.5ZM366.697 250.5C365.868 250.5 365.197 251.172 365.197 252C365.197 252.828 365.868 253.5 366.697 253.5L366.697 250.5ZM360.603 253.5C361.432 253.5 362.103 252.828 362.103 252C362.103 251.172 361.432 250.5 360.603 250.5L360.603 253.5ZM357.557 250.5C356.728 250.5 356.057 251.172 356.057 252C356.057 252.828 356.728 253.5 357.557 253.5L357.557 250.5ZM351.463 253.5C352.292 253.5 352.963 252.828 352.963 252C352.963 251.172 352.292 250.5 351.463 250.5L351.463 253.5ZM348.417 250.5C347.588 250.5 346.917 251.172 346.917 252C346.917 252.828 347.588 253.5 348.417 253.5L348.417 250.5ZM342.323 253.5C343.152 253.5 343.823 252.828 343.823 252C343.823 251.172 343.152 250.5 342.323 250.5L342.323 253.5ZM339.277 250.5C338.448 250.5 337.777 251.172 337.777 252C337.777 252.828 338.448 253.5 339.277 253.5L339.277 250.5ZM333.183 253.5C334.012 253.5 334.683 252.828 334.683 252C334.683 251.172 334.012 250.5 333.183 250.5L333.183 253.5ZM330.137 250.5C329.308 250.5 328.637 251.172 328.637 252C328.637 252.828 329.308 253.5 330.137 253.5L330.137 250.5ZM324.043 253.5C324.872 253.5 325.543 252.828 325.543 252C325.543 251.172 324.872 250.5 324.043 250.5L324.043 253.5ZM320.997 250.5C320.168 250.5 319.497 251.172 319.497 252C319.497 252.828 320.168 253.5 320.997 253.5L320.997 250.5ZM314.903 253.5C315.732 253.5 316.403 252.828 316.403 252C316.403 251.172 315.732 250.5 314.903 250.5L314.903 253.5ZM311.857 250.5C311.028 250.5 310.357 251.172 310.357 252C310.357 252.828 311.028 253.5 311.857 253.5L311.857 250.5ZM305.763 253.5C306.592 253.5 307.263 252.828 307.263 252C307.263 251.172 306.592 250.5 305.763 250.5L305.763 253.5ZM302.717 250.5C301.888 250.5 301.217 251.172 301.217 252C301.217 252.828 301.888 253.5 302.717 253.5L302.717 250.5ZM296.623 253.5C297.452 253.5 298.123 252.828 298.123 252C298.123 251.172 297.452 250.5 296.623 250.5L296.623 253.5ZM293.577 250.5C292.748 250.5 292.077 251.172 292.077 252C292.077 252.828 292.748 253.5 293.577 253.5L293.577 250.5ZM287.483 253.5C288.312 253.5 288.983 252.828 288.983 252C288.983 251.172 288.312 250.5 287.483 250.5L287.483 253.5ZM284.437 250.5C283.608 250.5 282.937 251.172 282.937 252C282.937 252.828 283.608 253.5 284.437 253.5L284.437 250.5ZM278.343 253.5C279.172 253.5 279.843 252.828 279.843 252C279.843 251.172 279.172 250.5 278.343 250.5L278.343 253.5ZM275.297 250.5C274.468 250.5 273.797 251.172 273.797 252C273.797 252.828 274.468 253.5 275.297 253.5L275.297 250.5ZM269.203 253.5C270.032 253.5 270.703 252.828 270.703 252C270.703 251.172 270.032 250.5 269.203 250.5L269.203 253.5ZM266.157 250.5C265.328 250.5 264.657 251.172 264.657 252C264.657 252.828 265.328 253.5 266.157 253.5L266.157 250.5ZM260.063 253.5C260.892 253.5 261.563 252.828 261.563 252C261.563 251.172 260.892 250.5 260.063 250.5L260.063 253.5ZM257.017 250.5C256.188 250.5 255.517 251.172 255.517 252C255.517 252.828 256.188 253.5 257.017 253.5L257.017 250.5ZM250.923 253.5C251.752 253.5 252.423 252.828 252.423 252C252.423 251.172 251.752 250.5 250.923 250.5L250.923 253.5ZM247.877 250.5C247.048 250.5 246.377 251.172 246.377 252C246.377 252.828 247.048 253.5 247.877 253.5L247.877 250.5ZM241.783 253.5C242.612 253.5 243.283 252.828 243.283 252C243.283 251.172 242.612 250.5 241.783 250.5L241.783 253.5ZM238.737 250.5C237.908 250.5 237.237 251.172 237.237 252C237.237 252.828 237.908 253.5 238.737 253.5L238.737 250.5ZM232.643 253.5C233.472 253.5 234.143 252.828 234.143 252C234.143 251.172 233.472 250.5 232.643 250.5L232.643 253.5ZM229.597 250.5C228.768 250.5 228.097 251.172 228.097 252C228.097 252.828 228.768 253.5 229.597 253.5L229.597 250.5ZM223.503 253.5C224.332 253.5 225.003 252.828 225.003 252C225.003 251.172 224.332 250.5 223.503 250.5L223.503 253.5ZM220.457 250.5C219.628 250.5 218.957 251.172 218.957 252C218.957 252.828 219.628 253.5 220.457 253.5L220.457 250.5ZM214.363 253.5C215.192 253.5 215.863 252.828 215.863 252C215.863 251.172 215.192 250.5 214.363 250.5L214.363 253.5ZM211.317 250.5C210.488 250.5 209.817 251.172 209.817 252C209.817 252.828 210.488 253.5 211.317 253.5L211.317 250.5ZM205.223 253.5C206.052 253.5 206.723 252.828 206.723 252C206.723 251.172 206.052 250.5 205.223 250.5L205.223 253.5ZM202.177 250.5C201.348 250.5 200.677 251.172 200.677 252C200.677 252.828 201.348 253.5 202.177 253.5L202.177 250.5ZM196.083 253.5C196.912 253.5 197.583 252.828 197.583 252C197.583 251.172 196.912 250.5 196.083 250.5L196.083 253.5ZM193.037 250.5C192.208 250.5 191.537 251.172 191.537 252C191.537 252.828 192.208 253.5 193.037 253.5L193.037 250.5ZM186.943 253.5C187.772 253.5 188.443 252.828 188.443 252C188.443 251.172 187.772 250.5 186.943 250.5L186.943 253.5ZM183.897 250.5C183.068 250.5 182.397 251.172 182.397 252C182.397 252.828 183.068 253.5 183.897 253.5L183.897 250.5ZM177.803 253.5C178.632 253.5 179.303 252.828 179.303 252C179.303 251.172 178.632 250.5 177.803 250.5L177.803 253.5ZM174.757 250.5C173.928 250.5 173.257 251.172 173.257 252C173.257 252.828 173.928 253.5 174.757 253.5L174.757 250.5ZM168.663 253.5C169.492 253.5 170.163 252.828 170.163 252C170.163 251.172 169.492 250.5 168.663 250.5L168.663 253.5ZM165.617 250.5C164.788 250.5 164.117 251.172 164.117 252C164.117 252.828 164.788 253.5 165.617 253.5L165.617 250.5ZM159.523 253.5C160.352 253.5 161.023 252.828 161.023 252C161.023 251.172 160.352 250.5 159.523 250.5L159.523 253.5ZM882.014 250.5C881.185 250.5 880.514 251.172 880.514 252C880.514 252.828 881.185 253.5 882.014 253.5L882.014 250.5ZM876.069 253.5C876.898 253.5 877.569 252.828 877.569 252C877.569 251.172 876.898 250.5 876.069 250.5L876.069 253.5ZM873.097 250.5C872.269 250.5 871.597 251.172 871.597 252C871.597 252.828 872.269 253.5 873.097 253.5L873.097 250.5ZM867.153 253.5C867.981 253.5 868.653 252.828 868.653 252C868.653 251.172 867.981 250.5 867.153 250.5L867.153 253.5ZM864.181 250.5C863.352 250.5 862.681 251.172 862.681 252C862.681 252.828 863.352 253.5 864.181 253.5L864.181 250.5ZM858.236 253.5C859.065 253.5 859.736 252.828 859.736 252C859.736 251.172 859.065 250.5 858.236 250.5L858.236 253.5ZM855.264 250.5C854.435 250.5 853.764 251.172 853.764 252C853.764 252.828 854.435 253.5 855.264 253.5L855.264 250.5ZM849.319 253.5C850.148 253.5 850.819 252.828 850.819 252C850.819 251.172 850.148 250.5 849.319 250.5L849.319 253.5ZM846.347 250.5C845.519 250.5 844.847 251.172 844.847 252C844.847 252.828 845.519 253.5 846.347 253.5L846.347 250.5ZM840.403 253.5C841.231 253.5 841.903 252.828 841.903 252C841.903 251.172 841.231 250.5 840.403 250.5L840.403 253.5ZM837.431 250.5C836.602 250.5 835.931 251.172 835.931 252C835.931 252.828 836.602 253.5 837.431 253.5L837.431 250.5ZM831.486 253.5C832.315 253.5 832.986 252.828 832.986 252C832.986 251.172 832.315 250.5 831.486 250.5L831.486 253.5ZM828.514 250.5C827.685 250.5 827.014 251.172 827.014 252C827.014 252.828 827.685 253.5 828.514 253.5L828.514 250.5ZM822.569 253.5C823.398 253.5 824.069 252.828 824.069 252C824.069 251.172 823.398 250.5 822.569 250.5L822.569 253.5ZM819.597 250.5C818.769 250.5 818.097 251.172 818.097 252C818.097 252.828 818.769 253.5 819.597 253.5L819.597 250.5ZM813.653 253.5C814.481 253.5 815.153 252.828 815.153 252C815.153 251.172 814.481 250.5 813.653 250.5L813.653 253.5ZM810.681 250.5C809.852 250.5 809.181 251.172 809.181 252C809.181 252.828 809.852 253.5 810.681 253.5L810.681 250.5ZM804.736 253.5C805.565 253.5 806.236 252.828 806.236 252C806.236 251.172 805.565 250.5 804.736 250.5L804.736 253.5ZM801.764 250.5C800.935 250.5 800.264 251.172 800.264 252C800.264 252.828 800.935 253.5 801.764 253.5L801.764 250.5ZM795.819 253.5C796.648 253.5 797.319 252.828 797.319 252C797.319 251.172 796.648 250.5 795.819 250.5L795.819 253.5ZM792.847 250.5C792.019 250.5 791.347 251.172 791.347 252C791.347 252.828 792.019 253.5 792.847 253.5L792.847 250.5ZM786.903 253.5C787.731 253.5 788.403 252.828 788.403 252C788.403 251.172 787.731 250.5 786.903 250.5L786.903 253.5ZM783.931 250.5C783.102 250.5 782.431 251.172 782.431 252C782.431 252.828 783.102 253.5 783.931 253.5L783.931 250.5ZM777.986 253.5C778.815 253.5 779.486 252.828 779.486 252C779.486 251.172 778.815 250.5 777.986 250.5L777.986 253.5ZM775.014 250.5C774.185 250.5 773.514 251.172 773.514 252C773.514 252.828 774.185 253.5 775.014 253.5L775.014 250.5ZM769.069 253.5C769.898 253.5 770.569 252.828 770.569 252C770.569 251.172 769.898 250.5 769.069 250.5L769.069 253.5ZM766.097 250.5C765.269 250.5 764.597 251.172 764.597 252C764.597 252.828 765.269 253.5 766.097 253.5L766.097 250.5ZM760.153 253.5C760.981 253.5 761.653 252.828 761.653 252C761.653 251.172 760.981 250.5 760.153 250.5L760.153 253.5ZM757.181 250.5C756.352 250.5 755.681 251.172 755.681 252C755.681 252.828 756.352 253.5 757.181 253.5L757.181 250.5ZM751.236 253.5C752.065 253.5 752.736 252.828 752.736 252C752.736 251.172 752.065 250.5 751.236 250.5L751.236 253.5ZM748.264 250.5C747.435 250.5 746.764 251.172 746.764 252C746.764 252.828 747.435 253.5 748.264 253.5L748.264 250.5ZM742.319 253.5C743.148 253.5 743.819 252.828 743.819 252C743.819 251.172 743.148 250.5 742.319 250.5L742.319 253.5ZM739.347 250.5C738.519 250.5 737.847 251.172 737.847 252C737.847 252.828 738.519 253.5 739.347 253.5L739.347 250.5ZM733.403 253.5C734.231 253.5 734.903 252.828 734.903 252C734.903 251.172 734.231 250.5 733.403 250.5L733.403 253.5ZM730.431 250.5C729.602 250.5 728.931 251.172 728.931 252C728.931 252.828 729.602 253.5 730.431 253.5L730.431 250.5ZM724.486 253.5C725.315 253.5 725.986 252.828 725.986 252C725.986 251.172 725.315 250.5 724.486 250.5L724.486 253.5ZM721.514 250.5C720.685 250.5 720.014 251.172 720.014 252C720.014 252.828 720.685 253.5 721.514 253.5L721.514 250.5ZM715.569 253.5C716.398 253.5 717.069 252.828 717.069 252C717.069 251.172 716.398 250.5 715.569 250.5L715.569 253.5ZM712.597 250.5C711.769 250.5 711.097 251.172 711.097 252C711.097 252.828 711.769 253.5 712.597 253.5L712.597 250.5ZM706.653 253.5C707.481 253.5 708.153 252.828 708.153 252C708.153 251.172 707.481 250.5 706.653 250.5L706.653 253.5ZM703.681 250.5C702.852 250.5 702.181 251.172 702.181 252C702.181 252.828 702.852 253.5 703.681 253.5L703.681 250.5ZM697.736 253.5C698.565 253.5 699.236 252.828 699.236 252C699.236 251.172 698.565 250.5 697.736 250.5L697.736 253.5ZM694.764 250.5C693.935 250.5 693.264 251.172 693.264 252C693.264 252.828 693.935 253.5 694.764 253.5L694.764 250.5ZM688.819 253.5C689.648 253.5 690.319 252.828 690.319 252C690.319 251.172 689.648 250.5 688.819 250.5L688.819 253.5ZM685.847 250.5C685.019 250.5 684.347 251.172 684.347 252C684.347 252.828 685.019 253.5 685.847 253.5L685.847 250.5ZM679.903 253.5C680.731 253.5 681.403 252.828 681.403 252C681.403 251.172 680.731 250.5 679.903 250.5L679.903 253.5ZM676.931 250.5C676.102 250.5 675.431 251.172 675.431 252C675.431 252.828 676.102 253.5 676.931 253.5L676.931 250.5ZM670.986 253.5C671.815 253.5 672.486 252.828 672.486 252C672.486 251.172 671.815 250.5 670.986 250.5L670.986 253.5ZM386.5 250.5L384.977 250.5L384.977 253.5L386.5 253.5L386.5 250.5ZM378.883 250.5L375.837 250.5L375.837 253.5L378.883 253.5L378.883 250.5ZM369.743 250.5L366.697 250.5L366.697 253.5L369.743 253.5L369.743 250.5ZM360.603 250.5L357.557 250.5L357.557 253.5L360.603 253.5L360.603 250.5ZM351.463 250.5L348.417 250.5L348.417 253.5L351.463 253.5L351.463 250.5ZM342.323 250.5L339.277 250.5L339.277 253.5L342.323 253.5L342.323 250.5ZM333.183 250.5L330.137 250.5L330.137 253.5L333.183 253.5L333.183 250.5ZM324.043 250.5L320.997 250.5L320.997 253.5L324.043 253.5L324.043 250.5ZM314.903 250.5L311.857 250.5L311.857 253.5L314.903 253.5L314.903 250.5ZM305.763 250.5L302.717 250.5L302.717 253.5L305.763 253.5L305.763 250.5ZM296.623 250.5L293.577 250.5L293.577 253.5L296.623 253.5L296.623 250.5ZM287.483 250.5L284.437 250.5L284.437 253.5L287.483 253.5L287.483 250.5ZM278.343 250.5L275.297 250.5L275.297 253.5L278.343 253.5L278.343 250.5ZM269.203 250.5L266.157 250.5L266.157 253.5L269.203 253.5L269.203 250.5ZM260.063 250.5L257.017 250.5L257.017 253.5L260.063 253.5L260.063 250.5ZM250.923 250.5L247.877 250.5L247.877 253.5L250.923 253.5L250.923 250.5ZM241.783 250.5L238.737 250.5L238.737 253.5L241.783 253.5L241.783 250.5ZM232.643 250.5L229.597 250.5L229.597 253.5L232.643 253.5L232.643 250.5ZM223.503 250.5L220.457 250.5L220.457 253.5L223.503 253.5L223.503 250.5ZM214.363 250.5L211.317 250.5L211.317 253.5L214.363 253.5L214.363 250.5ZM205.223 250.5L202.177 250.5L202.177 253.5L205.223 253.5L205.223 250.5ZM196.083 250.5L193.037 250.5L193.037 253.5L196.083 253.5L196.083 250.5ZM186.943 250.5L183.897 250.5L183.897 253.5L186.943 253.5L186.943 250.5ZM177.803 250.5L174.757 250.5L174.757 253.5L177.803 253.5L177.803 250.5ZM168.663 250.5L165.617 250.5L165.617 253.5L168.663 253.5L168.663 250.5ZM159.523 250.5L158 250.5L158 253.5L159.523 253.5L159.523 250.5ZM883.5 250.5L882.014 250.5L882.014 253.5L883.5 253.5L883.5 250.5ZM876.069 250.5L873.097 250.5L873.097 253.5L876.069 253.5L876.069 250.5ZM867.153 250.5L864.181 250.5L864.181 253.5L867.153 253.5L867.153 250.5ZM858.236 250.5L855.264 250.5L855.264 253.5L858.236 253.5L858.236 250.5ZM849.319 250.5L846.347 250.5L846.347 253.5L849.319 253.5L849.319 250.5ZM840.403 250.5L837.431 250.5L837.431 253.5L840.403 253.5L840.403 250.5ZM831.486 250.5L828.514 250.5L828.514 253.5L831.486 253.5L831.486 250.5ZM822.569 250.5L819.597 250.5L819.597 253.5L822.569 253.5L822.569 250.5ZM813.653 250.5L810.681 250.5L810.681 253.5L813.653 253.5L813.653 250.5ZM804.736 250.5L801.764 250.5L801.764 253.5L804.736 253.5L804.736 250.5ZM795.819 250.5L792.847 250.5L792.847 253.5L795.819 253.5L795.819 250.5ZM786.903 250.5L783.931 250.5L783.931 253.5L786.903 253.5L786.903 250.5ZM777.986 250.5L775.014 250.5L775.014 253.5L777.986 253.5L777.986 250.5ZM769.069 250.5L766.097 250.5L766.097 253.5L769.069 253.5L769.069 250.5ZM760.153 250.5L757.181 250.5L757.181 253.5L760.153 253.5L760.153 250.5ZM751.236 250.5L748.264 250.5L748.264 253.5L751.236 253.5L751.236 250.5ZM742.319 250.5L739.347 250.5L739.347 253.5L742.319 253.5L742.319 250.5ZM733.403 250.5L730.431 250.5L730.431 253.5L733.403 253.5L733.403 250.5ZM724.486 250.5L721.514 250.5L721.514 253.5L724.486 253.5L724.486 250.5ZM715.569 250.5L712.597 250.5L712.597 253.5L715.569 253.5L715.569 250.5ZM706.653 250.5L703.681 250.5L703.681 253.5L706.653 253.5L706.653 250.5ZM697.736 250.5L694.764 250.5L694.764 253.5L697.736 253.5L697.736 250.5ZM688.819 250.5L685.847 250.5L685.847 253.5L688.819 253.5L688.819 250.5ZM679.903 250.5L676.931 250.5L676.931 253.5L679.903 253.5L679.903 250.5ZM670.986 250.5L669.5 250.5L669.5 253.5L670.986 253.5L670.986 250.5Z",
    fill: "#B8C3D6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_614_1580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.5 195C672.5 274.253 608.253 338.5 529 338.5C449.747 338.5 385.5 274.253 385.5 195C385.5 115.747 449.747 51.5 529 51.5C608.253 51.5 672.5 115.747 672.5 195Z",
    stroke: "#E1E6EF",
    strokeWidth: 25,
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 110,
    width: 122,
    height: 37,
    rx: 18.5,
    fill: "#8A97AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M502.824 120.904V122.75C502.815 125.079 502.815 127.329 502.051 130.889L499.537 130.66C499.845 129.386 500.029 128.252 500.144 127.215L490.977 127.654L490.66 125.633L500.293 125.316C500.328 124.481 500.328 123.699 500.328 122.926H491.17V120.904H502.824ZM489.518 133.842V131.803H504.23V133.842H489.518ZM511.191 121.098V127.391H507.922V129.878C509.398 129.852 510.778 129.781 512.316 129.5L512.527 131.539C510.479 131.926 508.687 131.961 506.656 131.961H505.496V125.422H508.748V123.102H505.479V121.098H511.191ZM511.842 127.004V124.965H513.354V119.832H515.709V134.932H513.354V127.004H511.842ZM516.676 135.688V119.551H519.066V135.688H516.676ZM534.184 119.551V130.449H531.652V119.551H534.184ZM521.527 128.516V120.799H529.139V122.803H524.041V126.494C526.774 126.477 528.567 126.371 530.457 126.02L530.633 128.023C528.453 128.454 526.423 128.516 522.951 128.516H521.527ZM522.283 133.684C525.869 133.174 527.293 131.311 527.293 129.641V129.342H529.93V129.641C529.921 131.311 531.318 133.156 534.975 133.684L533.955 135.635C531.318 135.239 529.543 134.114 528.603 132.594C527.645 134.097 525.869 135.23 523.268 135.635L522.283 133.684ZM553.766 119.568V131.1H551.234V119.568H553.766ZM540.424 124.666C540.415 122.293 542.393 120.562 544.889 120.57C547.385 120.562 549.354 122.293 549.354 124.666C549.354 127.083 547.385 128.797 544.889 128.797C542.393 128.797 540.415 127.083 540.424 124.666ZM542.832 135.424V129.939H545.398V133.402H554.17V135.424H542.832ZM542.885 124.666C542.885 125.923 543.746 126.6 544.889 126.6C545.987 126.6 546.849 125.923 546.84 124.666C546.849 123.444 545.987 122.759 544.889 122.768C543.746 122.759 542.885 123.444 542.885 124.666ZM570.482 126.916V128.938H555.77V126.916H570.482ZM556.35 124.473C559.347 124.209 560.779 123.242 561.21 122.293H557.105V120.271H569.146V122.293H565.007C565.438 123.233 566.861 124.209 569.92 124.473L569.041 126.441C565.895 126.16 563.943 125.035 563.1 123.541C562.265 125.035 560.349 126.16 557.193 126.441L556.35 124.473ZM557.422 132.682C557.422 130.783 559.558 129.676 563.1 129.676C566.606 129.676 568.725 130.783 568.725 132.682C568.725 134.606 566.606 135.705 563.1 135.688C559.558 135.705 557.422 134.606 557.422 132.682ZM560.006 132.682C559.988 133.438 560.981 133.736 563.1 133.736C565.165 133.736 566.185 133.438 566.193 132.682C566.185 131.943 565.165 131.627 563.1 131.627C560.981 131.627 559.988 131.943 560.006 132.682Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 234,
    width: 122,
    height: 37,
    rx: 18.5,
    fill: "#8A97AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M502.824 245.904V247.75C502.815 250.079 502.815 252.329 502.051 255.889L499.537 255.66C499.845 254.386 500.029 253.252 500.144 252.215L490.977 252.654L490.66 250.633L500.293 250.316C500.328 249.481 500.328 248.699 500.328 247.926H491.17V245.904H502.824ZM489.518 258.842V256.803H504.23V258.842H489.518ZM511.191 246.098V252.391H507.922V254.878C509.398 254.852 510.778 254.781 512.316 254.5L512.527 256.539C510.479 256.926 508.687 256.961 506.656 256.961H505.496V250.422H508.748V248.102H505.479V246.098H511.191ZM511.842 252.004V249.965H513.354V244.832H515.709V259.932H513.354V252.004H511.842ZM516.676 260.688V244.551H519.066V260.688H516.676ZM534.184 244.551V255.449H531.652V244.551H534.184ZM521.527 253.516V245.799H529.139V247.803H524.041V251.494C526.774 251.477 528.567 251.371 530.457 251.02L530.633 253.023C528.453 253.454 526.423 253.516 522.951 253.516H521.527ZM522.283 258.684C525.869 258.174 527.293 256.311 527.293 254.641V254.342H529.93V254.641C529.921 256.311 531.318 258.156 534.975 258.684L533.955 260.635C531.318 260.239 529.543 259.114 528.603 257.594C527.645 259.097 525.869 260.23 523.268 260.635L522.283 258.684ZM553.871 244.551V260.688H551.357V252.725H548.369V250.668H551.357V244.551H553.871ZM540.002 255.994C543.975 254.017 545.565 251.617 545.908 248.189H540.775V246.221H548.457C548.457 251.178 546.998 255.142 541.285 257.963L540.002 255.994ZM562.344 246.062V252.443H558.617V255.089C560.041 255.08 561.403 255.019 562.924 254.781L563.1 256.803C561.034 257.146 559.32 257.198 557.334 257.207H556.191V250.457H559.9V248.102H556.174V246.062H562.344ZM563.768 259.914V244.797H566.07V250.562H567.371V244.551H569.762V260.688H567.371V252.584H566.07V259.914H563.768Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1924 278.781V280.768H35.0596V282.086H39.8408V284.055H35.0596V285.435C37.5469 285.408 39.1729 285.32 40.9834 285.021L41.2646 286.955C39.1113 287.377 37.125 287.456 33.8818 287.447H32.4932V278.781H40.1924ZM34.2158 293.424V288.396H36.7471V291.402H45.3252V293.424H34.2158ZM42.2666 289.486V277.568H44.7979V282.262H46.8896V284.301H44.7979V289.486H42.2666ZM62.2529 289.803V291.824H47.5049V289.803H53.5342V286.252H56.0479V289.803H62.2529ZM47.7861 284.758C51.7061 284.178 53.4111 281.69 53.4287 279.537V278.43H56.1357V279.537C56.127 281.726 57.8408 284.178 61.8135 284.758L60.7412 286.867C57.832 286.357 55.8281 284.907 54.7734 282.991C53.7275 284.898 51.7412 286.366 48.8584 286.867L47.7861 284.758ZM79.9365 277.551V280.943H82.0283V283.018H79.9365V286.516H77.4053V277.551H79.9365ZM66.8584 284.951C70.3564 284.107 72.2285 282.438 72.6064 280.469H67.667V278.465H75.3838C75.375 282.798 72.7207 285.689 67.8604 286.955L66.8584 284.951ZM69.2842 293.494V287.096H79.9365V293.494H69.2842ZM71.7979 291.525H77.4404V289.117H71.7979V291.525ZM97.3564 285.426V287.43H91.2393V288.678H95.5811V293.67H93.0498V290.682H84.2783V288.678H88.708V287.43H82.6436V285.426H97.3564ZM83.1885 283.088C86.748 282.868 88.1719 281.919 88.4795 280.943H84.0146V278.992H88.708V277.604H91.2393V278.992H95.9502V280.943H91.459C91.7578 281.919 93.1904 282.868 96.7764 283.088L95.9854 284.969C92.9619 284.775 90.9756 283.976 89.9648 282.754C88.9541 283.976 86.9678 284.775 83.9443 284.969L83.1885 283.088ZM108.325 280.979C108.316 283.896 109.336 286.806 112.017 288.098L110.505 290.102C108.817 289.284 107.719 287.808 107.068 285.979C106.383 287.948 105.196 289.539 103.386 290.418L101.839 288.361C104.687 287.078 105.785 284.002 105.794 280.979V278.746H108.325V280.979ZM112.491 293.688V277.551H115.022V283.668H117.308V285.795H115.022V293.688H112.491ZM122.3 278.219C124.33 278.21 125.974 279.37 126.448 281.066H128.927V277.551H131.44V286.234H128.927V283.053H126.457C126 284.793 124.339 285.962 122.3 285.971C119.812 285.962 117.958 284.327 117.976 282.068C117.958 279.854 119.812 278.21 122.3 278.219ZM120.366 282.068C120.366 283.185 121.166 283.853 122.3 283.844C123.398 283.853 124.181 283.185 124.181 282.068C124.181 280.952 123.398 280.311 122.3 280.311C121.166 280.311 120.366 280.952 120.366 282.068ZM120.577 293.512V286.902H123.056V288.291H128.927V286.902H131.44V293.512H120.577ZM123.056 291.473H128.927V290.225H123.056V291.473ZM139.456 281.77C139.438 284.187 140.572 287.017 143.323 288.273L141.917 290.26C140.142 289.46 138.929 287.913 138.217 286.076C137.514 288.115 136.248 289.82 134.394 290.682L132.935 288.678C135.738 287.386 136.89 284.406 136.89 281.77V281.137H133.603V279.08H142.585V281.137H139.456V281.77ZM143.604 293.688V277.551H146.136V283.598H148.421V285.689H146.136V293.688H143.604ZM40.0781 313.148C40.0869 309.844 41.1504 307.102 42.8555 304.729H45.7207C44.4902 306.486 43.1719 309.993 43.1719 313.148C43.1719 316.312 44.4902 319.819 45.7207 321.586H42.8555C41.1504 319.204 40.0869 316.453 40.0781 313.148ZM51.6797 318H47.0215V305.273H51.6797C55.5645 305.273 57.9551 307.655 57.9551 311.637C57.9551 315.609 55.5645 318 51.6797 318ZM50.0098 315.434H51.5742C53.7539 315.442 54.9492 314.396 54.9492 311.637C54.9492 308.868 53.7539 307.831 51.5391 307.822H50.0098V315.434ZM64.1602 318.176C61.1719 318.176 59.3438 316.312 59.3438 313.271C59.3438 310.31 61.1895 308.332 64.0547 308.332C66.7354 308.332 68.6602 310.037 68.6602 313.201V313.957H62.2617V314.01C62.2705 315.231 63.0088 316.031 64.2129 316.031C65.0215 316.031 65.6279 315.68 65.8652 315.117H68.625C68.2646 316.98 66.6299 318.176 64.1602 318.176ZM62.2617 312.217H65.9004C65.8828 311.197 65.1445 310.477 64.125 310.477C63.0791 310.477 62.3057 311.232 62.2617 312.217ZM79.1191 308.455L75.832 318H72.4395L69.1699 308.455H72.2812L74.0918 315.082H74.1973L75.9902 308.455H79.1191ZM84.3926 318.176C81.4043 318.176 79.5762 316.312 79.5762 313.271C79.5762 310.31 81.4219 308.332 84.2871 308.332C86.9678 308.332 88.8926 310.037 88.8926 313.201V313.957H82.4941V314.01C82.5029 315.231 83.2412 316.031 84.4453 316.031C85.2539 316.031 85.8604 315.68 86.0977 315.117H88.8574C88.4971 316.98 86.8623 318.176 84.3926 318.176ZM82.4941 312.217H86.1328C86.1152 311.197 85.377 310.477 84.3574 310.477C83.3115 310.477 82.5381 311.232 82.4941 312.217ZM93.3926 305.273V318H90.4219V305.273H93.3926ZM99.7207 318.176C96.7412 318.176 94.9219 316.198 94.9219 313.254C94.9219 310.31 96.7412 308.332 99.7207 308.332C102.709 308.332 104.52 310.31 104.52 313.254C104.52 316.198 102.709 318.176 99.7207 318.176ZM97.9453 313.236C97.9365 314.836 98.5693 315.935 99.7383 315.943C100.872 315.935 101.505 314.836 101.496 313.236C101.505 311.646 100.872 310.538 99.7383 310.529C98.5693 310.538 97.9365 311.646 97.9453 313.236ZM106.049 321.586V308.455H108.984V310.09H109.09C109.441 309.229 110.259 308.332 111.779 308.332C113.801 308.332 115.594 309.888 115.594 313.236C115.594 316.471 113.897 318.141 111.779 318.141C110.312 318.141 109.459 317.323 109.09 316.453H109.02V321.586H106.049ZM108.949 313.219C108.949 314.801 109.617 315.82 110.76 315.82C111.92 315.82 112.562 314.792 112.553 313.219C112.562 311.663 111.929 310.652 110.76 310.652C109.608 310.652 108.949 311.637 108.949 313.219ZM121.605 318.176C118.617 318.176 116.789 316.312 116.789 313.271C116.789 310.31 118.635 308.332 121.5 308.332C124.181 308.332 126.105 310.037 126.105 313.201V313.957H119.707V314.01C119.716 315.231 120.454 316.031 121.658 316.031C122.467 316.031 123.073 315.68 123.311 315.117H126.07C125.71 316.98 124.075 318.176 121.605 318.176ZM119.707 312.217H123.346C123.328 311.197 122.59 310.477 121.57 310.477C120.524 310.477 119.751 311.232 119.707 312.217ZM127.635 318V308.455H130.518V310.178H130.605C130.957 308.93 131.801 308.323 132.855 308.314C133.128 308.323 133.453 308.367 133.699 308.42V311.004C133.418 310.916 132.882 310.854 132.521 310.863C131.414 310.854 130.597 311.628 130.605 312.779V318H127.635ZM139.922 313.148C139.913 316.453 138.85 319.204 137.145 321.586H134.279C135.51 319.819 136.828 316.312 136.828 313.148C136.828 309.993 135.51 306.486 134.279 304.729H137.145C138.85 307.102 139.913 309.844 139.922 313.148Z",
    fill: "#5A6372"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M968.488 362.551V378.688H965.922V362.551H968.488ZM954.865 373.994C958.97 372.061 960.692 369.67 961.053 366.189H955.779V364.221H963.637C963.628 369.195 962.055 373.247 956.184 375.998L954.865 373.994ZM974.939 363.219C976.97 363.21 978.613 364.37 979.088 366.066H981.566V362.551H984.08V371.234H981.566V368.053H979.097C978.64 369.793 976.979 370.962 974.939 370.971C972.452 370.962 970.598 369.327 970.615 367.068C970.598 364.854 972.452 363.21 974.939 363.219ZM973.006 367.068C973.006 368.185 973.806 368.853 974.939 368.844C976.038 368.853 976.82 368.185 976.82 367.068C976.82 365.952 976.038 365.311 974.939 365.311C973.806 365.311 973.006 365.952 973.006 367.068ZM973.217 378.512V371.902H975.695V373.291H981.566V371.902H984.08V378.512H973.217ZM975.695 376.473H981.566V375.225H975.695V376.473Z",
    fill: "#5A6372"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M968.805 159.551V175.688H966.396V167.566H965.148V175.002H962.811V159.973H965.148V165.527H966.396V159.551H968.805ZM954.602 170.678C957.73 168.806 959.102 166.617 959.427 163.523H955.48V161.52H961.896C961.896 166.134 960.578 169.764 956.061 172.418L954.602 170.678ZM983.975 159.568V171.1H981.443V159.568H983.975ZM970.633 164.666C970.624 162.293 972.602 160.562 975.098 160.57C977.594 160.562 979.562 162.293 979.562 164.666C979.562 167.083 977.594 168.797 975.098 168.797C972.602 168.797 970.624 167.083 970.633 164.666ZM973.041 175.424V169.939H975.607V173.402H984.379V175.424H973.041ZM973.094 164.666C973.094 165.923 973.955 166.6 975.098 166.6C976.196 166.6 977.058 165.923 977.049 164.666C977.058 163.444 976.196 162.759 975.098 162.768C973.955 162.759 973.094 163.444 973.094 164.666Z",
    fill: "#5A6372"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_614_1580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 900,
    y: 0,
    width: 140,
    height: 140
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 70,
    r: 70,
    fill: "#5D38E5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_614_1580)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_614_1580)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 70,
    r: 70,
    fill: "url(#paint0_linear_614_1580)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1006.4 99.5716C1006.4 82.6244 990.103 68.886 970 68.886C949.897 68.886 933.6 82.6244 933.6 99.5716",
    stroke: "white",
    strokeWidth: 5.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970.7,
    cy: 44.1,
    r: 14.7,
    stroke: "white",
    strokeWidth: 5.6
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_614_1580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 900,
    y: 0,
    width: 140,
    height: 140
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 70,
    r: 70,
    fill: "#5D38E5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_614_1580)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_614_1580)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 970,
    cy: 70,
    r: 70,
    fill: "url(#paint1_linear_614_1580)"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M970.4 76.2859C954.345 76.2859 940.718 85.0483 935.881 97.2097C933.839 102.341 938.477 106.971 944 106.971H996.8C1002.32 106.971 1006.96 102.341 1004.92 97.2096C1000.08 85.0483 986.455 76.2859 970.4 76.2859Z",
    fill: "url(#paint2_linear_614_1580)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 971.101,
    cy: 51.5,
    r: 17.5,
    fill: "url(#paint3_linear_614_1580)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 917,
    y: 259,
    width: 64,
    height: 84,
    rx: 10,
    fill: "url(#paint4_linear_614_1580)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_614_1580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 946,
    y: 224,
    width: 77,
    height: 119,
    rx: 10,
    fill: "url(#paint5_linear_614_1580)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_614_1580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 957,
    y: 242,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint6_linear_614_1580)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_614_1580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 989,
    y: 242,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint7_linear_614_1580)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_614_1580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 957,
    y: 259,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint8_linear_614_1580)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_614_1580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 957,
    y: 276,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint9_linear_614_1580)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_614_1580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 989,
    y: 259,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint10_linear_614_1580)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_614_1580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 989,
    y: 276,
    width: 24,
    height: 10,
    rx: 5,
    fill: "url(#paint11_linear_614_1580)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_614_1580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 975,
    y: 307,
    width: 24,
    height: 36,
    rx: 2,
    fill: "url(#paint12_linear_614_1580)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68 163C68 150.85 58.1503 141 46 141C33.8497 141 24 150.85 24 163C24 175.15 33.8497 185 46 185C58.1503 185 68 175.15 68 163Z",
    fill: "url(#paint13_linear_614_1580)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.062 184.763L44.6733 191.871",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7949 134.187L47.4062 141.295",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9678 164.201L75.0765 164.59",
    stroke: "#FF9898",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3921 161.468L24.5008 161.856",
    stroke: "#FF9898",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.772 179.222L65.5237 184.525",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9453 141.534L31.697 146.824",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0301 177.566L24.7393 182.318",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7296 143.74L62.4263 148.492",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5994 182.543L33.4399 188.924",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.016 137.133L55.8691 143.514",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2246 183.647L55.5064 190.379",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9634 135.678L39.2452 142.411",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5008 161.856L17.3921 161.468",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0765 164.59L67.9678 164.201",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7485 172.664L72.1301 175.811",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3384 150.234L26.7199 153.394",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8521 156.039L73.5846 153.757",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8838 172.3L25.6164 170.018",
    stroke: "#5D38E5",
    strokeWidth: 4.01652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M123.969 192.955V241.987",
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0015 225.538V241.987",
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M51.104 242.814H133.511",
    stroke: "#5D38E5",
    strokeWidth: 5.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_614_1580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.395 227.786H28.6294L50.2349 176.638H134L112.395 227.786Z",
    fill: "url(#paint14_linear_614_1580)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_614_1580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.146 225.538H27.3809L48.9864 174.391H132.752L111.146 225.538Z",
    fill: "url(#paint15_linear_614_1580)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 50.7534 176)",
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 61.8682 175.39)",
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 74.354 175.39)",
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 86.8398 175.39)",
    stroke: "white"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 99.3257 175.39)",
    stroke: "white"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 111.812 175.39)",
    stroke: "white"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 53.6892,
    y2: -0.5,
    transform: "matrix(-0.38655 0.922268 -1 -4.03136e-08 124.297 175.39)",
    stroke: "white"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 130 176.541)",
    stroke: "white"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 125.58 188.057)",
    stroke: "white"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 121.16 199.572)",
    stroke: "white"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 116.741 211.087)",
    stroke: "white"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 82.3213,
    y2: -0.5,
    transform: "matrix(-1 -5.13615e-08 0.353783 -0.921779 112.321 222.603)",
    stroke: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 151L89.0984 154.902L93 156.5L89.0984 158.098L87.5 162L85.9016 158.098L82 156.5L85.9016 154.902L87.5 151Z",
    fill: "#E3DCFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 200L24.0984 203.902L28 205.5L24.0984 207.098L22.5 211L20.9016 207.098L17 205.5L20.9016 203.902L22.5 200Z",
    fill: "#E3DCFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 178L11.0984 181.902L15 183.5L11.0984 185.098L9.5 189L7.90159 185.098L4 183.5L7.90159 181.902L9.5 178Z",
    fill: "#E3DCFF"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_614_1580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.506 182.829C536.878 182.839 538.226 183.241 539.419 183.996C540.613 184.752 541.612 185.836 542.321 187.145C543.03 188.454 543.426 189.943 543.47 191.471C543.514 192.999 543.206 194.514 542.574 195.87C541.941 197.227 541.007 198.381 539.86 199.22C538.713 200.06 537.391 200.558 536.022 200.666C534.653 200.774 533.281 200.489 532.039 199.837C530.797 199.186 529.726 198.191 528.929 196.947C528.299 199.576 527.187 202.032 525.662 204.158C524.137 206.284 522.233 208.035 520.069 209.3V215.124H527.645V206.671C530.038 208.269 532.779 209.105 535.569 209.088C538.067 209.087 540.527 208.411 542.738 207.117C544.948 205.823 546.844 203.951 548.261 201.661C549.679 199.371 550.575 196.732 550.874 193.971C551.172 191.21 550.864 188.409 549.976 185.81C549.087 183.211 547.645 180.891 545.774 179.05C543.902 177.208 541.656 175.901 539.23 175.239C536.805 174.578 534.271 174.583 531.847 175.253C529.423 175.924 527.181 177.24 525.315 179.088C527.046 181.318 528.302 183.954 528.992 186.8C529.709 185.601 530.676 184.614 531.81 183.923C532.945 183.231 534.213 182.856 535.506 182.829V182.829Z",
    fill: "#5D3BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.465 206.476C482.152 207.622 484.026 208.384 485.98 208.718C488.232 209.13 490.539 208.978 492.732 208.273C494.926 207.568 496.95 206.327 498.658 204.641C496.908 202.425 495.634 199.794 494.934 196.947C494.101 198.202 492.984 199.189 491.696 199.806C490.409 200.423 488.998 200.649 487.606 200.461C486.215 200.273 484.893 199.677 483.776 198.734C482.659 197.792 481.786 196.536 481.247 195.096C480.708 193.655 480.522 192.081 480.708 190.534C480.893 188.987 481.444 187.522 482.303 186.29C483.163 185.057 484.301 184.101 485.601 183.517C486.901 182.934 488.317 182.746 489.704 182.971C491.644 183.356 493.397 184.499 494.649 186.193C495.901 187.888 496.569 190.024 496.535 192.218C496.619 196.144 497.907 199.921 500.183 202.922C502.46 205.922 505.59 207.965 509.053 208.713C512.516 209.461 516.104 208.869 519.224 207.034C522.343 205.199 524.805 202.232 526.202 198.625C527.599 195.019 527.846 190.988 526.904 187.203C525.961 183.418 523.885 180.105 521.02 177.814C518.154 175.523 514.671 174.392 511.149 174.608C507.627 174.823 504.276 176.373 501.654 179C503.406 181.25 504.669 183.919 505.346 186.8C506.151 185.509 507.251 184.481 508.533 183.822C509.814 183.163 511.23 182.897 512.634 183.052C514.039 183.206 515.381 183.775 516.522 184.701C517.662 185.626 518.56 186.874 519.123 188.315C519.685 189.757 519.892 191.339 519.721 192.899C519.551 194.459 519.009 195.94 518.152 197.189C517.296 198.438 516.155 199.409 514.848 200.002C513.541 200.596 512.116 200.79 510.719 200.565C508.873 200.228 507.188 199.189 505.952 197.626C504.715 196.062 504.003 194.07 503.936 191.988C503.397 179.918 495.711 175.665 490.877 174.8C488.877 174.44 486.832 174.523 484.861 175.044C482.889 175.566 481.029 176.515 479.388 177.838C477.746 179.161 476.355 180.831 475.295 182.754C474.234 184.676 473.524 186.813 473.206 189.041C473.082 189.917 473.014 190.802 473 191.688V215H480.465V206.476Z",
    fill: "#5D3BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.579 174.641C567.368 174.64 565.182 175.171 563.172 176.197C561.161 177.223 559.373 178.721 557.931 180.588V166.947H550.355V181.223C552.157 184.368 553.114 188.02 553.114 191.75C553.114 195.48 552.157 199.132 550.355 202.276V208.788H557.931V202.947C559.726 205.273 562.049 207.02 564.657 208.005C567.265 208.991 570.063 209.179 572.759 208.549C575.455 207.92 577.949 206.497 579.983 204.428C582.016 202.359 583.513 199.721 584.318 196.788H576.188C575.326 198.172 574.13 199.256 572.737 199.914C571.345 200.572 569.814 200.777 568.321 200.506C566.828 200.234 565.435 199.497 564.303 198.38C563.171 197.263 562.346 195.812 561.925 194.194H584.889C584.99 193.381 585.042 192.562 585.047 191.741C585.031 187.19 583.392 182.833 580.492 179.626C577.591 176.42 573.666 174.627 569.579 174.641V174.641ZM562.448 187.753C563.097 186.261 564.11 185.003 565.371 184.123C566.632 183.242 568.091 182.775 569.579 182.775C571.068 182.775 572.527 183.242 573.788 184.123C575.049 185.003 576.062 186.261 576.711 187.753H562.448Z",
    fill: "#5D3BE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_614_1580",
    x: 355,
    y: 25,
    width: 348,
    height: 348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.444618 0 0 0 0 0.479663 0 0 0 0 0.541667 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_614_1580",
    x: 900,
    y: 0,
    width: 157,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_614_1580",
    x: 900,
    y: 0,
    width: 157,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_614_1580",
    x: 942,
    y: 220,
    width: 85,
    height: 127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_614_1580",
    x: 953,
    y: 238,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_614_1580",
    x: 985,
    y: 238,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_614_1580",
    x: 953,
    y: 255,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_614_1580",
    x: 953,
    y: 272,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_614_1580",
    x: 985,
    y: 255,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_614_1580",
    x: 985,
    y: 272,
    width: 32,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_614_1580",
    x: 971,
    y: 303,
    width: 32,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_614_1580",
    x: 24.6294,
    y: 172.638,
    width: 113.371,
    height: 59.1471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_614_1580",
    x: 23.3809,
    y: 170.391,
    width: 113.371,
    height: 59.1471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_614_1580"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_614_1580",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_614_1580",
    x1: 1021,
    y1: 6.5,
    x2: 919,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129404,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_614_1580",
    x1: 1021,
    y1: 6.5,
    x2: 919,
    y2: 132.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129404,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_614_1580",
    x1: 970.4,
    y1: 76.2859,
    x2: 970.4,
    y2: 106.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_614_1580",
    x1: 971.101,
    y1: 34,
    x2: 971.101,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_614_1580",
    x1: 949,
    y1: 259,
    x2: 949,
    y2: 343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_614_1580",
    x1: 946,
    y1: 346.5,
    x2: 1025,
    y2: 221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B09AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF99FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_614_1580",
    x1: 984.5,
    y1: 242,
    x2: 957,
    y2: 252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_614_1580",
    x1: 1016.5,
    y1: 242,
    x2: 989,
    y2: 252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_614_1580",
    x1: 984.5,
    y1: 259,
    x2: 957,
    y2: 269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_614_1580",
    x1: 984.5,
    y1: 276,
    x2: 957,
    y2: 286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_614_1580",
    x1: 1016.5,
    y1: 259,
    x2: 989,
    y2: 269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_614_1580",
    x1: 1016.5,
    y1: 276,
    x2: 989,
    y2: 286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_614_1580",
    x1: 1002.5,
    y1: 307,
    x2: 971.678,
    y2: 310.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_614_1580",
    x1: 24,
    y1: 163,
    x2: 68,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E5AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_614_1580",
    x1: 28.6294,
    y1: 229.29,
    x2: 42.9597,
    y2: 156.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B09AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF99FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_614_1580",
    x1: 27.3809,
    y1: 227.042,
    x2: 41.7112,
    y2: 154.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#977AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_614_1580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 48,
    fill: "white",
    transform: "translate(473 167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainGraph);
export default __webpack_public_path__ + "static/media/main_graph.904e443f73433d21853b1bd71bc0aef6.svg";
export { ForwardRef as ReactComponent };